import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=1e43ea33&"
import script from "./Voting.vue?vue&type=script&lang=ts&"
export * from "./Voting.vue?vue&type=script&lang=ts&"
import style0 from "./Voting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports